import type { CartLine } from "@/shared/cart/model.types";
import { ensureClientItemId } from "@/shared/ids/client-item-id";

/** Legacy persisted shape (pre–PR 4). */
export type LegacyPersistedCartLine = CartLine & { stale?: boolean };

/**
 * Strips deprecated `stale` from cart lines loaded from persistence.
 * Catalog drift is resolved via {@link resolveCartValidity} — not line flags.
 *
 * Also remints non-UUID {@code client_item_id} values. Backend Guid binding rejects
 * {@code cid-...} fallbacks that appear on non-secure CUSTOM_HOSTNAME origins.
 */
export function sanitizePersistedCartLine(line: LegacyPersistedCartLine): CartLine {
  const { stale: _removed, ...rest } = line;
  return {
    ...rest,
    client_item_id: ensureClientItemId(rest.client_item_id),
  };
}

export function sanitizePersistedCartLines(lines: LegacyPersistedCartLine[]): CartLine[] {
  return lines.map(sanitizePersistedCartLine);
}
